import React from 'react';

import { CustomLinkItem } from '@app/gen/side_menu';

import { sidebarCustomIcons } from '../helpers';

import { SidebarItem } from './SidebarItem';

interface SidebarCustomLinkItemProps {
  item: CustomLinkItem;
  sidebarOpened: boolean;
  isSkeletonLoading: boolean;
  pathname: string;
  onMenuItemClick: (pageTitle: string) => void;
  isActive: (path: string, href: string) => boolean;
}

export const SidebarCustomLinkItem = ({
  item,
  sidebarOpened,
  isSkeletonLoading,
  pathname,
  isActive,
  onMenuItemClick,
}: SidebarCustomLinkItemProps) => {
  const { name, link, icon } = item;
  const isActiveItem = isActive(pathname, link);

  const icons = sidebarCustomIcons();
  const sidebarIcon = icon ? icons[icon] : icons.globe;

  return (
    <SidebarItem
      href={link}
      icon={sidebarIcon}
      aqaClass={`aqa_${name}`}
      title={name}
      sidebarOpened={sidebarOpened}
      isActive={isActiveItem}
      skeletonLoading={isSkeletonLoading}
      onClick={onMenuItemClick}
      isCustom
    />
  );
};
